import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import reportsschema from '../config/reports.js';
// import appconfig from '../config/shared.js';

import { format as date_format, parse as date_parse } from 'date-fns';

import reports_statusevents from './store_reports_statusevents.js';
import reports_checkstatus  from './store_reports_checkstatus.js';
import checks from './store_checks.js';

Vue.use(Vuex);

const axiosconfig = {
    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        // "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
    }
};

var timers = {};
const alertlife = 4500;

const store = new Vuex.Store({
    modules: { reports_statusevents, reports_checkstatus, checks },
    state: {
        currentUser: (window.cid && window.cid !== "_cid_") ? { customer_id: window.cid } : false,
        now: (() => {
            let time = new Date();
            return {
                stamp: date_format(time, 'x'),
                date: date_format(time, 'YYYY-MM-DD'),
                timestamp: date_format(time, 'HH:mm')
            }
        })(), // { stamp: null, date: null, timestamp: null },
        initDone: (window.cid && window.cid !== "_cid_"),
        statusmessage: '',
        account: {},
        contacts: {},
        checks: {},
        billing: {},
        reportschemas: reportsschema,
        systemAlerts: {}
    },
    mutations: {
        clear (state) {
            state.currentUser = false;
            state.account = {};
            state.contacts = {};
            state.check = {};
            state.billing = {};
        },
        initDone (state, val) {
            state.initDone = val;
        },
        setAccount (state, val) {
            state.account = val;
        },
        removeAlert (state, val) {
            if(val && val.key && state.systemAlerts[val.key]){
                // delete state.systemAlerts[val.key];
                Vue.delete(state.systemAlerts, val.key);
                // console.log("mutation removing", val);
            } else {
                // console.log("mutation can't remove", val, state.systemAlerts);
            }
        },
        setAlert (state, val) {
            if(val && val.key ) Vue.set(state.systemAlerts, val.key, val);
            // console.log('set', val, state.systemAlerts);
        },
        setCurrentUser (state, val) {
            state.currentUser = val;
        },
        setNow (state, val) {
            state.now = val;
        },
        setStatusMessage (state, val) {
            state.statusmessage = val;
        }
    },
    actions: {
        fetchAccount ({ commit, state }, data) {
            return axios.post("/account/get", {}, axiosconfig)
                .then((data) => {
                    let result = data && (data.data || data);
                    if (result && result._id){
                        if (result.contacts[result.currentcontact]){
                            let currentUser = result.contacts[result.currentcontact] || {};
                            currentUser.customer_name = result.customer_name;
                            currentUser.contactid = currentUser.currentcontact;
                            currentUser.email = result.email;

                            this.commit('setCurrentUser', currentUser);
                        }
                        this.commit('setAccount', data);
                        if (!state.initDone) setTimeout(() => { this.commit('initDone', true); }, 300) // avoid initial state race condition in router
                    } else {
                        if (!state.initDone) this.commit('initDone', true);
                    }
                })
                .catch((e) => {
                    // console.log('error', e)
                });
        },
        login ({ commit, state }, data) {
            let ndata = {
                login: data.username || data.email,
                password: data.password,
                cors: true,
                format: "json"
            }

            return axios.post("/account", ndata, axiosconfig)
                .then((resp) => {
                    // console.log(resp, state)
                    let result = data && (data.data || data);
                    if (result && result._id){
                        if (result.contacts[result.currentcontact]){
                            let currentUser = result.contacts[result.currentcontact] || {};
                            currentUser.customer_name = result.customer_name;
                            currentUser.contactid = currentUser.currentcontact;

                            this.commit('setCurrentUser', currentUser);
                        }
                        this.commit('setAccount', data);
                    }
                })
                .catch((e) => {
                    // console.log('error', e)
                });
        },
        logout ({ commit, state }, data) {
            return axios.get("/account/logout", axiosconfig)
                .then((resp) => {
                    this.commit('clear');
                    // console.log('logged out', resp, state)
                })
                .catch((e) => {
                    // console.log('error', e)
                });        },
        setNow ({ commit, state }, data) {
            let time = (data && date_parse(data)) || new Date();
            let nt = {
                stamp: date_format(time, 'x'),
                date: date_format(time, 'YYYY-MM-DD'),
                timestamp: date_format(time, 'HH:mm')
            };
            this.commit("setNow", nt);
            return Promise.resolve(nt);
        },
        setAlert ({ commit, state }, data) {
            if(typeof data === 'string') data = { message: data };
            data.key = data.key || Date.now().toString(36);
            let types = ['success', 'info', 'warning', 'error'];
            data.type = (data.type && types.indexOf(data.type) > -1) ? data.type : "info";

            this.commit('setAlert', data);

            if(timers[data.key]) clearTimeout(data.key);
            timers[data.key] = setTimeout(() => {
                // console.log('clearing', data.key)
                this.commit('removeAlert', {key: data.key, message: null});
                if( timers[data.key] ) delete timers[data.key];
            }, alertlife)


        }
    },
    getters: {
        currentUser: state => state.currentUser,
        checkIds: state => (state.checks && Object.keys(state.checks)) || []
    }
});

export default store;

store.dispatch('fetchAccount');
store.dispatch('setNow'); // this is probably not the right way to do this.
setInterval( function () { store.dispatch('setNow'); }, 60000);
